import Vue from 'vue'
import * as alertMutationTypes from '../store/modules/alert/mutation-types'
import { i18n } from '../plugins/vue-i18n'
import { buildAlertMessage } from '../types/alert-message'

export default {
  methods: {
    showAlert (message) {
      Vue.prototype.$container.store.commit(`alert/${alertMutationTypes.ADD_ALERT_MESSAGE}`, buildAlertMessage(message))
    },
    showAlertForError (error, codeToMessageMap = {}) {
      Vue.prototype.$container.log.debug(error)
      if (error.code === 500 && !codeToMessageMap[error.code]) {
        error.message = i18n.t('generic.service-error')
      }
      this.showAlert(codeToMessageMap[error.code] || error.message)
    },
    showAlertForErrorAndRedirectToRoute (error, codeToMessageMap = {}, codeToRouteMap = {}) {
      if (codeToRouteMap[error.code]) {
        Vue.prototype.$container.router.push(codeToRouteMap[error.code])
      }
      this.showAlertForError(error, codeToMessageMap)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/show-alert-error-handler.js